import React, { useRef } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Button,
  Breadcrumb,
} from "react-bootstrap";
import {
  FiDownload,
  FiArrowLeft,
  FiPrinter,
  FiCopy,
} from "react-icons/fi";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";



const InvoiceDetails = () => {
  const invoiceRef = useRef();

  // ✅ DOWNLOAD FUNCTION (PDF)
  const handleDownload = () => {
    const printContents = invoiceRef.current.innerHTML;
    const newWindow = window.open("", "", "width=900,height=700");
    newWindow.document.write(`
      <html>
        <head>
          <title>Invoice</title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
          <style>
            body{padding:20px}
          </style>
        </head>
        <body>
          ${printContents}
        </body>
      </html>
    `);
    newWindow.document.close();
    newWindow.print();
  };

  return (
    <Container fluid className="page-wrapper">
      <div className="content">

        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Invoices</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/invoices-page" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                   Application
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Invoices</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

          <Button className="btn-dark d-flex align-items-center" onClick={handleDownload}>
            <FiDownload className="me-2" /> Download
          </Button>
        </div>

        {/* Back */}
        <a href="/" className="back-link">
          <FiArrowLeft /> Back to List
        </a>

        {/* Invoice Card */}
        <Row>
          <Col md={10} className="mx-auto">
            <Card ref={invoiceRef}>
              <Card.Body>

                {/* Header */}
                <Row className="border-bottom mb-3 align-items-center">
                  <Col md={6}>
                    <img src="/assets/img/logo-1.svg" width="130" alt="logo" />
                    <p className="mt-2">
                      3099 Kennedy Court Framingham, MA 01702
                    </p>
                  </Col>

                  <Col md={6} className="text-end">
                    <h5>
                      Invoice No <span style={{color:"#ff6b1a"}} className="">#INV0001</span>
                    </h5>
                    <p>Created Date : Sep 24, 2023</p>
                    <p>Due Date : Sep 30, 2023</p>
                  </Col>
                </Row>

                {/* From / To */}
                <Row className="border-bottom mb-3">
                  <Col md={5}>
                    <h6>From</h6>
                    <h5>Thomas Lawler</h5>
                    <p>2077 Chicago Avenue Orosi, CA 93647</p>
                    <p>Email : example@mail.com</p>
                    <p>Phone : +1 987 654 3210</p>
                  </Col>

                  <Col md={5}>
                    <h6>To</h6>
                    <h5>Sara Inc,.</h5>
                    <p>3103 Trainer Avenue Peoria, IL 61602</p>
                    <p>Email : example@mail.com</p>
                    <p>Phone : +1 987 471 6589</p>
                  </Col>

                  <Col md={2}>
                    <h6>Payment Status</h6>
                    <span className="badge bg-danger mb-2">
                      Due in 10 Days
                    </span>
                    <img
                      src="/assets/img/qr.svg"
                      className="img-fluid"
                      alt="QR"
                    />
                  </Col>
                </Row>

                {/* Table */}
                <p>
                  Invoice For : <strong>Design & development of Website</strong>
                </p>

                <Table responsive>
                  <thead className="table-light">
                    <tr>
                      <th>Job Description</th>
                      <th className="text-end">Qty</th>
                      <th className="text-end">Cost</th>
                      <th className="text-end">Discount</th>
                      <th className="text-end">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      ["UX Strategy", "$500"],
                      ["Design System", "$5000"],
                      ["Brand Guidelines", "$5000"],
                      ["Social Media Template", "$5000"],
                    ].map((item, i) => (
                      <tr key={i}>
                        <td>{item[0]}</td>
                        <td className="text-end">1</td>
                        <td className="text-end">{item[1]}</td>
                        <td className="text-end">$100</td>
                        <td className="text-end">{item[1]}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                {/* Summary */}
                <Row className="border-bottom mb-3">
                  <Col md={7}>
                    <h6>Terms and Conditions</h6>
                    <p>
                      Please pay within 15 days from the date of invoice.
                    </p>

                    <h6>Notes</h6>
                    <p>Please quote invoice number.</p>
                  </Col>

                  <Col md={5}>
                    <div className="d-flex justify-content-between">
                      <span>Sub Total</span>
                      <strong>$5500</strong>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span>Discount</span>
                      <strong>$400</strong>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span>VAT</span>
                      <strong>$54</strong>
                    </div>

                    <div className="d-flex justify-content-between mt-2">
                      <h5>Total</h5>
                      <h5>$5775</h5>
                    </div>
                  </Col>
                </Row>

                {/* Footer */}
                <div className="text-center">
                  <img src="/assets/img/logo-1.svg" width="120" alt="logo" />
                  <p>Payment via bank transfer</p>
                  <small>HDFC Bank | IFSC: HDFC0018159</small>
                </div>

              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Buttons */}
        <div className="text-center mt-4">
          <Button  cl style={{ background: "#ff6b1a",}} className="me-2 border border-1">
            <FiPrinter className="me-2" />
            Print Invoice
          </Button>

          <Button style={{background:"#ffff"}} variant="outline-secondary text-dark">
            <FiCopy className="me-2" />
            Clone Invoice
          </Button>
        </div>

      </div>
      <style>
          {
               `
               .page-wrapper {
  background: #f5f6fa;
  padding: 20px;
}

.card {
  border-radius: 10px;
  border: 1px solid #eee;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
  text-decoration: none;
  color: #333;
  font-size: 14px;
}

.table th,
.table td {
  vertical-align: middle;
  font-size: 14px;
}

.badge {
  font-size: 12px;
  padding: 6px 10px;
}

/* MOBILE */
@media (max-width: 768px) {
  .text-end {
    text-align: left !important;
  }

  .page-breadcrumb {
    flex-direction: column;
    gap: 10px;
  }
}`
          }
      </style>
    </Container>
  );
};

export default InvoiceDetails;